// extracted by mini-css-extract-plugin
module.exports = {"root":"PriceInfo_root__NiLmj","root_right":"PriceInfo_root_right__vHlME"};